import React from 'react';
// permissions
import { GROUPS, ACCESS } from 'app/config/consts';
// components
const NotFound = React.lazy(() => import('app/components/pages/notfound/NotFound'));
const PeformVisitModal = React.lazy(() =>
  import('app/components/modals/peform-visit/PeformVisitModal')
);

const basePath = '/window-modal';

const ROUTES = [
  {
    exact: true,
    path: `${basePath}/peform-visit/:id`,
    component: PeformVisitModal,
    notFoundComponent: NotFound,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      //
    ],
    whoCanAccess: [ACCESS.CLIENT /* , ACCESS.BUSINESS_PARTNER */]
  },

  {
    exact: false,
    path: '*',
    component: NotFound,
    notFoundComponent: NotFound,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      //
    ],
    whoCanAccess: [ACCESS.CLIENT /* , ACCESS.BUSINESS_PARTNER */]
  }
];

/**
 *
 * @param {*} account
 */
export function getWindowModalRoutes(account) {
  const { groupId, businessPartnerId } = account;

  const groupFilter = ROUTES.filter(r => r.canAccess.includes(groupId));

  if (businessPartnerId !== null)
    return groupFilter.filter(r => r.whoCanAccess.includes(ACCESS.BUSINESS_PARTNER));

  return groupFilter;
}
